import { render, staticRenderFns } from "./RecentProjectsLoaderState.vue?vue&type=template&id=6e9bc7b2&"
import script from "./RecentProjectsLoaderState.vue?vue&type=script&lang=js&"
export * from "./RecentProjectsLoaderState.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports